/**
 * Mirrors NewUser.to_dict() (app/models.py) minus `password`, as returned by
 * both POST /v2/auth/api-login and GET /v2/auth/session. Kept intentionally
 * loose (most fields optional) since to_dict() dumps raw SQLAlchemy columns
 * and nullable columns can legitimately be null/absent.
 */
export interface User {
  user_id: string
  email: string
  firstname?: string | null
  lastname?: string | null
  phone?: string | null
  company_id?: string | null
  is_admin: boolean
  is_super_user: boolean
  is_staff: boolean
  is_client: boolean
  is_manager?: boolean
  is_owner?: boolean
  is_installer?: boolean
}

export interface NavLeaf {
  key: string
  label: string
  icon_svg: string
  href: string
}

export interface NavGroup {
  key: string
  label: string
  icon_svg: string
  children: NavLeaf[]
}

export type NavEntry = NavLeaf | NavGroup

export function isNavGroup(entry: NavEntry): entry is NavGroup {
  return 'children' in entry
}

/**
 * Global platform settings (see backend app/models.py's PlatformSetting) -
 * exposed to every authenticated user regardless of role, since a flag
 * like new_system_overview_dashboard_enabled changes the DEFAULT landing
 * view for everyone, not just something admin-only UI needs. Keyed loosely
 * (not a fixed literal union) since more flags may be added over time
 * without a frontend type change.
 */
export type PlatformSettings = Record<string, boolean>

export interface SessionResponse {
  authenticated: boolean
  user: User | null
  permissions: string[]
  nav: NavEntry[]
  settings: PlatformSettings
}

export interface LoginResponse {
  status: 'success' | 'error'
  message: string
  user: User | Record<string, never>
  authenticated: boolean
}
